import {Component, Input} from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import {CallPreferencesService} from './call-preferences.service';

/**
 * The "Do not disturb for calls" switch (ITP-E-171-04). Two looks over one CallPreferencesService: an icon button
 * beside the chat's Call button ('icon'), and a labelled pill under the missed-call banners ('pill'). Either is a
 * real switch (role="switch", aria-checked), so a screen reader hears its state.
 */
@Component({
  selector: 'app-dnd-toggle',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  templateUrl: './dnd-toggle.component.html',
  styleUrls: ['./dnd-toggle.component.scss']
})
export class DndToggleComponent {
  static readonly label = 'Do not disturb for calls';

  @Input() variant: 'icon' | 'pill' = 'icon';

  readonly doNotDisturb$ = this.callPreferences.doNotDisturb$;
  readonly label = DndToggleComponent.label;

  constructor(private callPreferences: CallPreferencesService) {
  }

  onToggle(): void {
    this.callPreferences.toggle().then();
  }

  tooltipOf(on: boolean): string {
    return on ? `${DndToggleComponent.label}: on — calls go straight to missed` : `${DndToggleComponent.label}: off`;
  }
}
